export default __webpack_public_path__ + "static/media/time.2da5f967.mp3";